import UIAlert from 'UIComponents/alert/UIAlert';
import I18n from 'I18n';
import { connect } from 'react-redux';
import { hideInvalidCodeAlert as hideInvalidCodeAlertAction } from '../../actions';
import { getIsInvalidCodeAlertVisible } from '../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
const InvalidCodeAlert = ({
  isInvalidCodeAlertVisible,
  hideInvalidCodeAlert
}) => {
  if (!isInvalidCodeAlertVisible) {
    return /*#__PURE__*/_jsx("div", {});
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: I18n.text('login.twoFactor.errors.invalidCode.title'),
    closeable: true,
    onClose: hideInvalidCodeAlert,
    children: I18n.text('login.twoFactor.errors.invalidCode.body')
  });
};
const mapStateToProps = state => ({
  isInvalidCodeAlertVisible: getIsInvalidCodeAlertVisible(state)
});
export default connect(mapStateToProps, {
  hideInvalidCodeAlert: hideInvalidCodeAlertAction
})(InvalidCodeAlert);